<div class="widget-card" [class.dark]="dark"
  [style.background]="isChromeless ? null : (cardColor || null)"
  (pointermove)="onPointerMove($event)"
  (pointerup)="onPointerUp($event)"
  (pointercancel)="onPointerUp($event)">

  <div class="widget-header" *ngIf="editing" (pointerdown)="onDragStart($event)">
    <span class="widget-drag-hint" aria-hidden="true">⣿</span>
    <span class="widget-header-title" [title]="displayTitle">{{ displayTitle }}</span>
    <div class="widget-header-actions">
      <button type="button" class="widget-icon-btn" (click)="configure.emit()"
        (pointerdown)="$event.stopPropagation()" aria-label="Configure widget">⚙</button>
      <button type="button" class="widget-icon-btn danger" (click)="remove.emit()"
        (pointerdown)="$event.stopPropagation()" aria-label="Remove widget">&times;</button>
    </div>
  </div>

  <div class="widget-content-slot">
    <ng-content></ng-content>
  </div>

  <div class="widget-resize-handle" *ngIf="editing"
    (pointerdown)="onResizeStart($event)" aria-hidden="true"></div>
</div>
